import { render, staticRenderFns } from "./AvatarModal.vue?vue&type=template&id=6ec0fe24&scoped=true"
import script from "./AvatarModal.vue?vue&type=script&lang=js"
export * from "./AvatarModal.vue?vue&type=script&lang=js"
import style0 from "./AvatarModal.vue?vue&type=style&index=0&id=6ec0fe24&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ec0fe24",
  null
  
)

export default component.exports